import styled from 'styled-components'
import {Button} from "../../forms/styled/form";
import {media} from "../../styled/themeVariables";
import {rem} from "polished";
import {FeaturedBuyBtn} from "../../featuredInSection/styled/featuredInSection";

export const BuyBtn = styled(Button)`
  display: none;
  position: absolute;
  right: 0;
  bottom: 4px;
  width: 100%;
  border-radius: 0;
  z-index: 10;
  background-color: rgba(35,18,0,0.8);
  color: ${(props) => props.theme.colors.bg};
  font-weight: normal;
  padding: ${rem(10)} ${rem(45)};
  font-size: ${rem(18)};

  &:hover {
    background-color: rgba(255,255,255,0.9);
    color: ${(props) => props.theme.colors.brandOppositeDark};
  }

  &:hover svg {

    fill: ${(props) => props.theme.colors.brandOppositeDark};
  }

  ${media.tablet`
    padding: ${rem(12)} ${rem(25)};
    font-size: ${rem(16)};
 `}
`;

export const PictureWrap = styled.div`
  position: relative;
  margin: 0 auto;
  cursor: pointer;

  &:hover ${BuyBtn},
  &:hover ${FeaturedBuyBtn} {
    display: block;
  }
`

export const MetaInfo = styled.div`
  text-align: center;
  color: #555;

  p {
    margin: 0;
    font-size: ${rem(13)};
  }
`

export const MetaTitle = styled.p`
  font-weight: 500;
  color: ${(props) => props.theme.colors.text};
`

export const MetaDimension = styled.p`
`

export const MetaVariants = styled.p`
`
